import { escapeHtml } from '../../utils';
import { getMessagesDiv } from './dom';
import { createMsgElement } from './message-element';
import { isAutoScrollPinned, scrollToBottom } from './scrollbar';
import type { AppendErrorOptions, ChatMessage } from './types';

export function appendSystemMessage(message: string | ChatMessage): void {
  const messagesDiv = getMessagesDiv();
  if (!messagesDiv) return;
  const welcome = messagesDiv.querySelector('.welcome-msg');
  if (welcome) welcome.remove();
  const normalized = typeof message === 'string'
    ? { role: 'system', content: message }
    : { role: 'system', ...(message || {}) };
  messagesDiv.appendChild(createMsgElement('system', normalized.content || '', [], normalized));
  scrollToBottom();
}

export function appendError(message: string, options: AppendErrorOptions = {}): void {
  const messagesDiv = getMessagesDiv();
  if (!messagesDiv) return;
  const errorType = options.type || 'error';
  const dismissible = options.dismissible !== false;

  const div = document.createElement('div');
  div.className = 'msg system error-msg';
  div.setAttribute('data-error-type', errorType);

  const bubbleStyle = options.style || 'border-color:var(--danger);color:var(--danger)';
  const icon = options.icon || '⚠';

  div.innerHTML = `<div class="msg-bubble" style="${bubbleStyle}">${icon} ${escapeHtml(message)}${dismissible ? '<button class="error-dismiss-btn" aria-label="关闭">×</button>' : ''}</div>`;

  if (dismissible) {
    const dismissBtn = div.querySelector('.error-dismiss-btn');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', () => div.remove());
    }
  }

  messagesDiv.appendChild(div);
  scrollToBottom();

  if (isAutoScrollPinned()) {
    div.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}
